<template>
  <div id="file">
    <div style="display:inline; color:rgb(66, 134, 241)" @click="showImagePreview">文件附件</div>
    <Modal title="查看文件附件" v-model="visible">
      <img :src="imageUrls" v-if="visible" style="width: 100%" />
    </Modal>
  </div>
</template>
<script>
export default {
  props: ['item'],
  data() {
    return {
      imageUrls: [],
      imgFile: false,
      visible: false,
    }
  },
  created: function () {
    this.getFieldName()
  },
  methods: {
    getFieldName: function () {
      if (this.item.type == 'SingleChoiceQuestion') {
        this.imageUrls = this.item.value.singleChoiceAttribute.imageUrls
      } else if (this.item.type == 'MultipleChoiceQuestion') {
        this.imageUrls = this.item.value.multipleChoiceAttribute.imageUrls
      } else if (this.item.type == 'DropDownQuestion') {
        this.imageUrls = this.item.value.dropDownAttribute.imageUrls
      } else if (this.item.type == 'SingleLineTextQuestion') {
        this.imageUrls = this.item.value.singleLineTextAttribute.imageUrls
      } else if (this.item.type == 'MultipleLineTextQuestion') {
        this.imageUrls = this.item.value.multipleLineTextAttribute.imageUrls
      } else if (this.item.type == 'ScaleQuestion') {
        this.imageUrls = this.item.value.scaleAttribute.imageUrls
      } else if (this.item.type == 'DigitalQuestion') {
        this.imageUrls = this.item.value.digitalAttribute.imageUrls
      } else if (this.item.type == 'FillInBlankQuestion') {
        this.imageUrls = this.item.value.fillInBlanksAttribute.imageUrls
      } else if (this.item.type == 'TimeQuestion') {
        this.imageUrls = this.item.value.timeAttribute.imageUrls
      } else if (this.item.type == 'DateTimeQuestion') {
        this.imageUrls = this.item.value.dateTimeAttribute.imageUrls
      } else if (this.item.type == 'DateQuestion') {
        this.imageUrls = this.item.value.dateAttribute.imageUrls
      } else if (this.item.type == 'RateQuestion') {
        this.imageUrls = this.item.value.rateAttribute.imageUrls
      } else if (this.item.type == 'FileUploadQuestion') {
        this.imageUrls = this.item.value.fileUploadAttribute.imageUrls
      }
    },
    showImagePreview: function () {
      this.visible = true
      // this.$createImagePreview({
      //   imgs: this.imageUrls
      // }).show();
    },
  },
}
</script>
<style lang="less">
#file .imgFile {
  /* background-color: #ccc; */
  width: 100%;
  height: 100%;
  z-index: 99;
}
#file .imgFile img {
  /* margin:0 auto; */
  width: 50%;
  height: 100px;
}
.border-bottom-1px:after {
  border: none;
}
</style>


